var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "WelcomeSupsisViews" } }, [
    _c("h1", [_vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisTitle")))]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-section" }, [
      _c("h2", [_vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisSelectedAi")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "system-grid" },
        _vm._l(_vm.systemOptions, function (value, key) {
          return _c(
            "div",
            { key: key, staticClass: "system-card", class: { active: value } },
            [
              _c("div", { staticClass: "icon-container" }, [
                value
                  ? _c("span", { staticClass: "check-icon" }, [_vm._v("✓")])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "system-name" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.systemLabels[key]) +
                    "\n                "
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-section" }, [
      _c("h2", [
        _vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisIntegratedModules"))),
      ]),
      _vm._v(" "),
      _vm.communicationModules.length
        ? _c("div", { staticClass: "module-category" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisCommModules"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-grid" },
              _vm._l(_vm.communicationModules, function (module, index) {
                return _c(
                  "div",
                  { key: "comm-" + index, staticClass: "module-card" },
                  [
                    _c("div", { staticClass: "module-icon" }, [
                      _vm._v(_vm._s(_vm.getModuleIcon(module))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "module-name" }, [
                      _vm._v(_vm._s(_vm.getModuleLabel(module))),
                    ]),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.businessModules.length
        ? _c("div", { staticClass: "module-category" }, [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisBizModules"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "module-grid" },
              _vm._l(_vm.businessModules, function (module, index) {
                return _c(
                  "div",
                  { key: "biz-" + index, staticClass: "module-card" },
                  [
                    _c("div", { staticClass: "module-icon" }, [
                      _vm._v(_vm._s(_vm.getModuleIcon(module))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "module-name" }, [
                      _vm._v(_vm._s(_vm.getModuleLabel(module))),
                    ]),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "preview-section" }, [
      _c("h2", [_vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisSurvey")))]),
      _vm._v(" "),
      _c("div", { staticClass: "survey-info" }, [
        _c("div", { staticClass: "info-item" }, [
          _c("span", { staticClass: "info-label" }, [
            _vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisSector"))),
          ]),
          _vm._v(
            "\n                " + _vm._s(_vm.surveySector) + "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("span", { staticClass: "info-label" }, [
            _vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisDepartment"))),
          ]),
          _vm._v(
            "\n                " +
              _vm._s(_vm.surveyDepartment) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info-item" }, [
          _c("span", { staticClass: "info-label" }, [
            _vm._v(_vm._s(_vm.$t("adminPanel.welcomeSupsisHeardAbout"))),
          ]),
          _vm._v(
            "\n                " + _vm._s(_vm.heardAboutUs) + "\n            "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }